<template>
<a :class="`profile-intro mb-4 ${noPhoto?'p-4':''}`" :href="detailTop && detailTop.link?'/#'+detailTop.link:''">

    <img class="profile-img" :src="detailTop.picture || '/img/user.jpg'" v-if="detailTop && !noPhoto">

    <div class="profile-info" style="flex:2">
        <!-- @if(detailTop.topSubtitle) -->
        <p v-if="detailTop && detailTop.topSubtitle" class="mb-2">{{detailTop.topSubtitle}}</p>
        <!-- @endif -->
        <!-- @if(detailTop.title) -->
        <h4 v-if="detailTop && detailTop.title" class="mb-1">{{detailTop.title}}</h4>
        <!-- @endif -->
        <!-- @if(detailTop.subtitle) -->
        <p v-if="detailTop && detailTop.subtitle" class="mb-2">{{detailTop.subtitle}}</p>
        <!-- @endif -->
        <!-- @if(detailTop.items && detailTop.items.length ) -->
        <div v-if="detailTop && detailTop.items && detailTop.items.length" class="profile-contact"  >
            <!-- @each(item in detailTop.items) -->
            <div v-for="item in detailTop.items" class="item" v-bind:key="item.content">
                <i class="material-symbols-outlined">{{item.icon}}</i>
                <span>{{item.content && item.content != null && item.content != 'null' ?item.content : 'Tidak Ada' }}</span>
            </div>
            <!-- @endeach -->
        </div>
        <!-- @endif -->

    </div>
    <div v-if="detailTop && detailTop.topRight && detailTop.topRight.length" style="flex:2;" class="pr-3">
      <div v-for="(row,index) in detailTop.topRight" v-bind:key="row.key+Math.random(1023)" :class="'row '+(index?'mt-2':'')">
        <div  v-for="item in row.columns" :class="'px-1 col-md-'+(item.colnum || 12/row.columns.length)" v-bind:key="item.label+Math.random(1023)" >
            <div class="item mr-0" >
              <span>
                <i class="material-symbols-outlined">{{item.icon}}</i>
              </span>
              <div>
                <span class="item-label font-heading">{{item.label}}</span>
                <h5 class="item-content font-body">{{item.content && item.content != null && item.content != 'null' ?item.content : 'Tidak Ada' }}</h5>
              </div><!---->
            </div>
        </div>
      </div>
    </div>
    <div v-else style="flex:1;" class="pr-4"></div>
</a>
</template>

<script>
export default {
  name: 'DetailTop',
  props: {
    detailTop:Object,
    noPhoto:Boolean
  }
}
</script>